export const getNumberFromString = (value) => {
  const numbers = value.replace(/[^\d]/g, '');
  if (numbers === '') return false;
  return parseInt(numbers, 10);
};

export const getUSCurrencyString = (number) => {
  return number
    .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    .replace(/\.\d*/g, '');
};
